// extracted by mini-css-extract-plugin
export default {"block":"Question_block__4eHf9","question":"Question_question__zCqPn","title-hid":"Question_title-hid__CdU6-","title":"Question_title__3tiq+"};